// src/utils/calculations.js
export function calculateDaysUsed(openDateIso, closeDateIso) {
  if (!openDateIso || !closeDateIso) return 0;
  const openDate = new Date(openDateIso);
  const closeDate = new Date(closeDateIso);
  const msPerDay = 24 * 60 * 60 * 1000;
  return Math.max(1, Math.round((closeDate - openDate) / msPerDay) + 1);
}

export function calculateHoursUsed(openDateIso, openTime, closeDateIso, closeTime) {
  if (!openDateIso || !closeDateIso || !openTime || !closeTime) return 0;
  const parseTime = (dateIso, time) => {
    const d = new Date(dateIso);
    const [h, m] = time.split(":").map(Number);
    d.setHours(h, m, 0, 0);
    return d;
  };
  const openDateTime = parseTime(openDateIso, openTime);
  const closeDateTime = parseTime(closeDateIso, closeTime);
  const msPerHour = 60 * 60 * 1000;
  const diffHours = (closeDateTime - openDateTime) / msPerHour;
  return diffHours > 0 ? Math.round(diffHours * 100) / 100 : 0;
}

export function calculateKmsUsed(openKm, closeKm) {
  const oKm = Number(openKm);
  const cKm = Number(closeKm);
  if (!oKm || !cKm || cKm < oKm) return 0;
  return cKm - oKm;
}
